import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Bell } from 'lucide-react';
import { api } from '../lib/api';

const POLL_MS = 30000;

const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const load = useCallback(() => {
    api.get('/notifications').then((r) => { setItems(r.data.items || []); setUnread(r.data.unread_count || 0); }).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, POLL_MS);
    return () => clearInterval(t);
  }, [load]);

  useEffect(() => {
    const onClick = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const markRead = (n) => {
    if (!n.is_read) {
      api.post(`/notifications/${n.id}/read`).then(load).catch(() => {});
    }
  };

  const markAllRead = () => { api.post('/notifications/read-all').then(load).catch(() => {}); };

  return (
    <div className="notif-wrap" ref={wrapRef}>
      <div className="crm-top-icon" data-testid="notifications-btn" onClick={() => setOpen((o) => !o)}>
        <Bell size={14} />
        {unread > 0 && <span className="notif-badge" data-testid="notifications-unread-badge">{unread > 9 ? '9+' : unread}</span>}
      </div>
      {open && (
        <div className="notif-dropdown" data-testid="notifications-dropdown">
          <div className="notif-dropdown-hd">
            <span>Notifications</span>
            {unread > 0 && <button onClick={markAllRead} data-testid="notifications-mark-all-read">Mark all read</button>}
          </div>
          {items.length === 0 ? (
            <div className="notif-empty" data-testid="notifications-empty">You're all caught up.</div>
          ) : (
            items.map((n) => (
              <div
                key={n.id} className={`notif-row${n.is_read ? '' : ' unread'}`}
                onClick={() => markRead(n)} data-testid={`notification-row-${n.id}`}
              >
                <div className="notif-row-title">{n.title}</div>
                <div className="notif-row-msg">{n.message}</div>
                <div className="notif-row-time">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
